module.exports = __webpack_public_path__ + "static/steamwhistle-logo-d3fee66be11cebad99335c30b00c1700.png";